// extracted by mini-css-extract-plugin
export default {"toggle":"styles_toggle__JVUxM","boxpadding":"styles_boxpadding__S+TFr","row":"styles_row__+yO3Z","heading":"styles_heading__VnXSQ","date":"styles_date__8SPcH"};